"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsHeader = void 0;
var React = require("react");
var SearchResultsService_1 = require("../services/SearchResultsService");
var getPageTitle = function (typeFiltersList, documentsSearchPageType) {
    var documentsTypeFilter = typeFiltersList.filter(function (filter) {
        return filter &&
            filter.value &&
            SearchResultsService_1.SearchResultsService.getFilterValueItself(filter.value) === documentsSearchPageType;
    })[0];
    return documentsTypeFilter && documentsTypeFilter.title;
};
exports.DocumentsHeader = React.memo(function (props) {
    var pageTitle = getPageTitle(props.typeFiltersList, props.documentsSearchPageType);
    if (!pageTitle)
        return null;
    return (React.createElement("div", { className: "container-fluid filterable-list__documents-search-header" },
        React.createElement("h1", { className: "page-heading" }, pageTitle)));
}, function () { return true; });
